// Site-wide constants for TinkerShift
export const CALENDLY_URL =
  "https://calendly.com/tinkertank/meet-with-julija-tinkertank-academy";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  {
    label: "Our Solutions",
    to: "/solutions",
    children: [
      { label: "Makerspace Strategy", to: "/solutions/strategy" },
      { label: "Professional Development", to: "/solutions/professional-development" },
      { label: "Launch & Activation", to: "/solutions/launch" },
      { label: "The Platform", to: "/solutions/platform" },
      { label: "Resources & Kits", to: "/solutions/resources" },
    ],
  },
  { label: "Schools", to: "/schools" },
  { label: "Libraries", to: "/libraries" },
  { label: "Framework", to: "/framework" },
  { label: "Platform", to: "/solutions/platform" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const COLORS = {
  teal: "#00C2B8",
  blue: "#0055FF",
  magenta: "#FF007F",
  yellow: "#FFD700",
  orange: "#FF6600",
  charcoal: "#1A1A1A",
};

export const PILLARS = [
  {
    title: "Create",
    color: COLORS.yellow,
    text: "#1A1A1A",
    blurb:
      "Imagination, storytelling, design and original ideas. Students start as makers, not consumers.",
  },
  {
    title: "Build",
    color: COLORS.orange,
    text: "#1A1A1A",
    blurb:
      "Hands-on making, prototyping, coding and robotics. Ideas become tangible, testable things.",
  },
  {
    title: "Solve",
    color: COLORS.magenta,
    text: "#FFFFFF",
    blurb:
      "Real-world challenges, systems thinking and creative problem-solving across domains.",
  },
  {
    title: "Share",
    color: COLORS.blue,
    text: "#FFFFFF",
    blurb:
      "Communication, confidence, portfolios and presentation. Learning that travels beyond the room.",
  },
  {
    title: "Adapt",
    color: COLORS.teal,
    text: "#1A1A1A",
    blurb:
      "Resilience, iteration, feedback and lifelong learning in a world that won't stop changing.",
  },
];

export const SERVICES = [
  {
    title: "Consulting",
    color: COLORS.blue,
    text: "#FFFFFF",
    blurb:
      "Inventory audits, gap analysis, purchasing guidance and strategic planning — we help you see exactly what you have, what you need and what to do next.",
  },
  {
    title: "Makerspace Setup",
    color: COLORS.yellow,
    text: "#1A1A1A",
    blurb:
      "Design and set up the physical space, choose and install the right equipment, and build a working makerspace — not an underused room full of boxes.",
  },
  {
    title: "Equipment Training",
    color: COLORS.magenta,
    text: "#FFFFFF",
    blurb:
      "Hands-on training on every piece of kit in your makerspace, so educators and staff know how to use it safely, confidently and creatively.",
  },
  {
    title: "Facilitator Development",
    color: COLORS.orange,
    text: "#1A1A1A",
    blurb:
      "The craft of being a makerspace facilitator — how to run sessions, scaffold projects and lead curious, hands-on learning that actually ships.",
  },
  {
    title: "Platform",
    color: COLORS.teal,
    text: "#1A1A1A",
    blurb:
      "A future SaaS platform for managing challenges, resources, student portfolios, reporting and support.",
    badge: "Coming Soon",
  },
];

export const SCHOOLS_BULLETS = [
  "Future-ready learning strategy",
  "STEM and makerspace curriculum",
  "Teacher professional development",
  "Facilitator training & capability",
  "Student portfolios and showcases",
  "Implementation planning",
];

export const LIBRARIES_BULLETS = [
  "Makerspace activation",
  "School holiday and after-school programs",
  "Staff training",
  "Community workshops",
  "Youth innovation programs",
  "Ongoing support and resources",
];

export const PLATFORM_TILES = [
  { title: "Challenge Library", color: COLORS.yellow, icon: "Puzzle" },
  { title: "Teacher Resources", color: COLORS.orange, icon: "BookOpen" },
  { title: "Student Portfolios", color: COLORS.magenta, icon: "FolderHeart" },
  { title: "Reporting", color: COLORS.blue, icon: "BarChart3" },
  { title: "Helpdesk", color: COLORS.teal, icon: "LifeBuoy" },
  { title: "Early Access", color: "#1A1A1A", icon: "Sparkles" },
];

export const STATS = [
  { value: "15,000+", label: "Students reached" },
  { value: "10+", label: "Years of delivery" },
  { value: "100s", label: "Schools, libraries & community programs" },
  { value: "PBL", label: "Proven project-based model" },
];

export const INTEREST_OPTIONS = [
  "Schools",
  "Libraries",
  "Platform",
  "Speaking",
  "Consulting",
];

export const FOUNDER_PHOTO =
  "https://customer-assets.emergentagent.com/job_shift-framework/artifacts/66rw8wau_Screenshot%202026-05-31%20at%201.57.36%20pm.png";

export const SCHOOLS_PHOTO =
  "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGFzc3Jvb20lMjBzdHVkZW50cyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzgxNTcyMjQ5fDA&ixlib=rb-4.1.0&q=85";

export const LIBRARIES_PHOTO =
  "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjbGFzc3Jvb20lMjBzdHVkZW50cyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzgxNTcyMjQ5fDA&ixlib=rb-4.1.0&q=85";
